export async function compressImage(file: File, maxDimension = 1920, quality = 0.7): Promise<File> {
  if (!file.type.startsWith('image/')) return file;
  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    if (width > height && width > maxDimension) {
      height = Math.round(height * (maxDimension / width));
      width = maxDimension;
    } else if (height >= width && height > maxDimension) {
      width = Math.round(width * (maxDimension / height));
      height = maxDimension;
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, file.type, quality));
    if (!blob) return file;
    return new File([blob], file.name, { type: file.type });
  } catch (err) {
    console.error('Image compression failed', err);
    return file;
  }
}
